import React, { memo, useState } from 'react'

import { useTheme } from '@material-ui/styles'
import { makeStyles, Typography, ButtonBase, Grid, Divider } from '@material-ui/core'
import IconPhone from '@material-ui/icons/Phone'

import track from '~/track'
import { formatPhoneNumber } from '~/utils'
import { useLiterals } from '~/components/Literals'
import useViewportSizes from '~/components/useViewportSize'
import ButtonWhatsapp from '~/containers/StoreInformations/ButtonWhatsapp'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    marginTop: 16,
    '& svg': {
      display: 'inline-block',
      verticalAlign: 'middle',
      marginRight: 8,
    },
    text: {
      fontSize: 14,
      color: theme.palette.text.primary,
    },
  },
  button: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '8px 16px',
    backgroundColor: '#F2F2F2',
    transition: 'filter .2s ease-in-out',
    '&:hover': {
      filter: 'brightness(95%)',
    },
  },
  icon: {
    width: 28,
    height: 28,
    padding: 4,
    borderRadius: 9999,
    backgroundColor: '#FFF',
  },
}))

function StoreContacts({ currentStore, onSeePhone, color = 'inherit', setOpenForm }) {
  const classes = useStyles()
  const theme = useTheme()
  const viewport = useViewportSizes()

  const [showPhone, setShowPhone] = useState(false)
  const { getLiteral } = useLiterals()
  const phoneNumber = formatPhoneNumber(currentStore?.phoneNumber)

  const [startNumber, _] = phoneNumber?.split('-')
  const isExistWhatsApp = !!currentStore?.whatsapp
  const isMobile = viewport.width < theme.gofind.desktopMaxWidth

  const handleSeePhone = (e) => {
    if (!showPhone) {
      e.stopPropagation()
      e.preventDefault()
      setShowPhone(true)

      track('cliqueVerTelefone', { category: 'menu', name: currentStore?.storeName })
      onSeePhone('phoneNumber')
      return
    }

    showPhone && track('cliqueLigar', { name: currentStore?.storeName, category: 'loja' })
  }

  // if (!phoneNumber?.trim()) return null

  return (
    <Grid className={classes.root} style={{ flexDirection: isMobile ? 'column' : 'row' }}>
      {phoneNumber && (
        <ButtonBase
          component="a"
          href={showPhone ? `tel:${phoneNumber}` : ''}
          target="_blank"
          variant="body1"
          color={color}
          style={{
            textDecoration: 'underline',
            borderRadius: isExistWhatsApp && phoneNumber ? (!isMobile ? '8px 0 0 8px' : '8px 8px 0 0') : 8,
          }}
          className={classes.button}
          data-cy="call"
          onClick={handleSeePhone}
        >
          <IconPhone className={classes.icon} style={{ color: '#97A8AB' }} />
          <Typography component="span" className={classes.text}>
            {showPhone ? phoneNumber : `${startNumber}-... ${String(getLiteral('1315')).toLocaleLowerCase()}`}
          </Typography>
        </ButtonBase>
      )}

      {phoneNumber && isExistWhatsApp && (
        <Divider
          flexItem
          orientation={isMobile ? 'horizontal' : 'vertical'}
          style={{
            backgroundColor: '#C5CDCF',
            ...(isMobile && { width: '100%', height: 1 }),
          }}
        />
      )}

      {!!currentStore?.whatsapp && <ButtonWhatsapp setOpenForm={setOpenForm} />}
    </Grid>
  )
}

export default memo(StoreContacts)
